import { PerkNoAds } from '../../../../shared/store/ColonistMembershipProduct.ts';
import { UIStoreMembershipProductView } from '../../../shared/scripts/store/UIStoreMembershipProductView.ts';
import { showSimpleDialog } from '../../../shared/scripts/ui_popup/showSimpleDialog.ts';
import { DiscordInstance } from '../discord/DiscordInstance.ts';
import { SDKRequest } from '../../../../shared/DiscordActivityTypes.ts';
import { createParagraphIn, setElementInnerHTML } from '../../../shared/scripts/ui_utils/DomUtils.ts';
import { getManageSubscriptionPopupBody, isPurchaseUnavailableOnPlatform, showUnavailableOnMobilePopup } from '../../../shared/scripts/store/StoreUtils.ts';
import { DiscordAnnualMembershipPrices } from '../../../../shared/store/StoreConstants.ts';
import { UIMembershipProductView } from '../../../shared/scripts/store/UIMembershipProductView.ts';
import { ColonistMembershipType } from '@colonist/types';
import { sendPurchaseSessionStartedAnalytic } from '../../../shared/scripts/analytics/sendPurchaseFunnelAnalytic.ts';
export class UIDStoreMembershipProductView extends UIStoreMembershipProductView {
    sendToCheckout() {
        if (isPurchaseUnavailableOnPlatform()) {
            showUnavailableOnMobilePopup();
            return;
        }
        sendPurchaseSessionStartedAnalytic({
            storeProductType: this.membershipProduct.storeProductType,
            productType: this.membershipProduct.type,
            method: 'discord'
        });
        void DiscordInstance.getDiscordInstance().sendSDKRequest(SDKRequest.PurchaseMembership, this.membershipProduct.type);
    }
    getValidMembershipPerks(membership) {
        const membershipPerks = super.getValidMembershipPerks(membership);
        const perksToFilter = [
            new PerkNoAds()
        ];
        const validPerks = membershipPerks.filter((perk)=>!perksToFilter.some((perkToFilter)=>perk.type === perkToFilter.type));
        UIMembershipProductView.mergeMapsAndExpansionDescriptions(validPerks);
        return validPerks;
    }
    getDisclaimerKey() {
        const yearlyPrice = this.getAnnualMembershipPrice();
        if (yearlyPrice == undefined) return {
            key: 'strings:storePage.sections.membership.billing.monthly'
        };
        if (this.membershipProduct.billedAnnually) return {
            key: 'strings:storePage.sections.membership.billing.annually',
            options: {
                context: 'nonRenewing',
                amount: `${yearlyPrice / 100}`
            }
        };
        return {
            key: 'strings:storePage.sections.membership.billing.monthly'
        };
    }
    setAnnualMembershipPriceText() {
        const yearlyPrice = this.getAnnualMembershipPrice();
        if (yearlyPrice == undefined) return;
        const monthlyPrice = yearlyPrice / 100 / 12;
        const roundedMonthlyPrice = monthlyPrice.toFixed(2);
        setElementInnerHTML(this.priceDiv, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        this.membershipPrice = createParagraphIn(this.priceDiv, {
            key: 'strings:storePage.sections.membership.billing.paidMonthly',
            options: {
                context: 'biggerPrice',
                amount: `${roundedMonthlyPrice}`,
                currency: '$'
            }
        }, '', '');
        const shouldShowStrikethroughPrice = this.membershipProduct.billedAnnually;
        if (!shouldShowStrikethroughPrice) return;
        this.showStrikeThroughPrice();
    }
    // eslint-disable-next-line class-methods-use-this
    manageSubscription() {
        UIDStoreMembershipProductView.createManageSubscriptionPopup();
    }
    static createManageSubscriptionPopup() {
        const popupTitle = {
            key: 'strings:storePage.manageMembership.title'
        };
        const popupBody = getManageSubscriptionPopupBody();
        showSimpleDialog({
            title: popupTitle,
            body: popupBody
        });
    }
    getAnnualMembershipPrice() {
        switch(this.membershipProduct.type){
            case ColonistMembershipType.PlusYearly:
                return DiscordAnnualMembershipPrices.PLUS;
            case ColonistMembershipType.PremiumYearly:
                return DiscordAnnualMembershipPrices.PREMIUM;
            case ColonistMembershipType.EliteYearly:
                return DiscordAnnualMembershipPrices.ELITE;
            default:
                return undefined;
        }
    }
    constructor(container, storeState, membershipProduct, giftOverlay){
        super(container, storeState, membershipProduct, giftOverlay);
        if (this.membershipProduct.billedAnnually) this.setAnnualMembershipPriceText();
    }
}
